var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"row"},[_c('design-2021-britannica-school-component',{attrs:{"school-id-in":_vm.schoolIdIn}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }